// extracted by mini-css-extract-plugin
export default {"root":"Login_root__dEqPf","card":"Login_card__S3cgd","input":"Login_input__MeaWb","submit":"Login_submit__aRE9j","link":"Login_link__eKW9P","footer":"Login_footer__-Y6A2"};